import { Box, Grid, Typography } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface ICharacterBoxesProps {
	value: string;
	totalBoxes: number;
}

const CharacterBoxes: FC<ICharacterBoxesProps> = ({ value, totalBoxes }) => {
	// Pad from left with empty strings so numbers appear right-aligned
	const chars = value ? value.toString().split("") : "";
	const padded = Array(totalBoxes - chars.length)
		.fill("")
		.concat(chars);

	return (
		<Box sx={{ display: "flex", gap: "2px" }}>
			{padded.map((char, index) => (
				<Box
					key={index}
					sx={{
						width: "24px",
						height: "28px",
						border: "1px solid #ccc",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						fontSize: "14px",
						fontWeight: char ? 500 : "normal",
						backgroundColor: "#fff",
					}}
				>
					{char}
				</Box>
			))}
		</Box>
	);
};

interface IPADAgreenmentBankFieldsPanel { accountantBankDetailsForPADData: any }
export const PADAgreenmentBankFieldsPanel: FC<
	IPADAgreenmentBankFieldsPanel
> = ({ accountantBankDetailsForPADData }) => {
	return (
		<Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
			{/* <Grid
				size={{ xs: 12 }}
				sx={{ display: "flex", alignItems: "center", mb: 1, gap: 2 }}
			>
				<Typography sx={{ minWidth: "115px", color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>
					Account Number
				</Typography>
				<CharacterBoxes value={"123456"} totalBoxes={18} />
			</Grid>

			<Grid
				size={{ xs: 12 }}
				sx={{ display: "flex", alignItems: "center", mb: 2, gap: 2 }}
			>
				<Typography sx={{ minWidth: "115px", color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>
					Transit Number
				</Typography>
				<CharacterBoxes value={"123"} totalBoxes={5} />

				<Typography sx={{ ml: 2.8, color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>Financial Institution Number</Typography>
				<CharacterBoxes value={"003"} totalBoxes={4} />
			</Grid> */}
			<Box sx={{ display: "inline-flex", flexDirection: "column", gap: 1, mb: "35px" }}>
				{/* Account Number Row */}
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography sx={{ width: "130px", flexShrink: 0, color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>
						Account Number
					</Typography>
					<CharacterBoxes value={accountantBankDetailsForPADData && accountantBankDetailsForPADData.accountNo} totalBoxes={18} />
				</Box>

				{/* Transit Number + Financial Institution Number Row */}
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography sx={{ width: "130px", flexShrink: 0, color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>
						Transit Number
					</Typography>
					<CharacterBoxes value={accountantBankDetailsForPADData && accountantBankDetailsForPADData.branchTransitNumber} totalBoxes={5} />
					{/* spacer to push Financial Institution to the right so its boxes align with Account Number boxes */}
					<Box sx={{ width: "51px", flexShrink: 0 }} />
					{/* <Box sx={{ width: "25px", flexShrink: 0 }} /> */}
					<Typography sx={{ width: "185px", flexShrink: 0, color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}>
						Financial Institution Number
					</Typography>
					<CharacterBoxes value={accountantBankDetailsForPADData && accountantBankDetailsForPADData.bankFinancialNo} totalBoxes={4} />
				</Box>
			</Box>


			{/* Name & Branch Address */}
			<RHookFormTextFieldWithLabel
				label="Name"
				id="bankName"
				testId={`answer-1`}
			/>
			<RHookFormTextFieldWithLabel
				id="branchAddress"
				label="Branch Address"
				testId={`answer-1`}
			/>
		</Grid>
	);
};
